import React, { Component, PropsWithChildren } from 'react';
import './FormGroup.scss';

/**
 * Basic wrapper for form groups
 */

export interface IFormGroupContext {
  updateFormGroupErrors: (field: string, hasError: boolean) => void;
  showFormGroupError: boolean;
  formGroupErrors: Map<string, boolean>;
}

export interface IFormGroupProps {
  /**
   * Note: currently only works with NaturalFieldText and NaturalFieldSelect components. Setting this will cause an error message to be displayed underneath the form group if one or more natural fields has a validation error.
   * If true, displays "Is required". If set to a string, displays that string.
   *
   * @default false
   */
  errorMessage?: string | boolean;
}
export interface IFormGroupState {
  errors: Map<string, boolean>;
  errorMessage?: boolean | string;
}
export const FormGroupContext = React.createContext<IFormGroupContext>({
  formGroupErrors: new Map(),
  showFormGroupError: false,
  updateFormGroupErrors: () => {
    /*noop*/
  },
});

export class FormGroup extends Component<PropsWithChildren<IFormGroupProps>, IFormGroupState> {
  constructor(props: IFormGroupProps) {
    super(props);
    this.state = {
      errorMessage: props.errorMessage,
      errors: new Map(),
    };
  }

  public render() {
    const errorMsg = this.state !== null && this.state.errorMessage === true ? 'Is required' : this.state.errorMessage;
    return (
      <>
        <FormGroupContext.Provider
          value={{
            formGroupErrors: this.state.errors,
            showFormGroupError: !!errorMsg,
            updateFormGroupErrors: this.updateFormGroupErrors,
          }}
        >
          <div className="form-group">{this.props.children}</div>
        </FormGroupContext.Provider>
        {this.state !== null && this.getShowError() && errorMsg && (
          <div className="hlc-form-element-error">{errorMsg}</div>
        )}
      </>
    );
  }

  public updateFormGroupErrors = (field: string, value: boolean) => {
    const newErrorMap = new Map(this.state.errors);
    newErrorMap.set(field, value);
    this.setState({ errors: newErrorMap });
  };

  private getShowError = () => {
    return this.state && this.state.errors && Array.from(this.state.errors.values()).some((value) => value === true);
  };
}

export default FormGroup;
